import { JhiDateUtils } from 'ng-jhipster';
import { BaseEntity } from './base-entity';

export type RegistrationState =
    'WAITING' |
    'PROCESSING' |
    'VISIT_NOT_CONFIRMED' |
    'ABANDONED_BY_USER' |
    'ABANDONED_BY_ADMIN' |
    'ABANDONED_EXPIRED' |
    'PROCESSED';

export type RegistrationMethod =
    'MOBILE' |
    'DEVICE' |
    'WWW' |
    'ADMIN';

export class Registration implements BaseEntity {
    constructor(public id?: number,
                public labelToDisplay?: string,
                public registrationDate?: any,
                public datePlanned?: any,
                public hourValid?: boolean,
                public startDateReal?: any,
                public endDateReal?: any,
                public priority?: number,
                public state?: RegistrationState,
                public method?: RegistrationMethod,
                public doneBy?: string,
                public queueId?: number,
                public queueName?: string,
                public userId?: number,
                public userFirstName?: string,
                public userLastName?: string,
                public userIndex?: string,
                public issueId?: number,
                public issueName?: string) {
        this.hourValid = false;
    }

    public convertToSimpleTypes(dateUtils: JhiDateUtils) {
        this.registrationDate = dateUtils.toDate(this.registrationDate);
        this.datePlanned = dateUtils.toDate(this.datePlanned);
        this.startDateReal = dateUtils.toDate(this.startDateReal);
        this.endDateReal = dateUtils.toDate(this.endDateReal);
    }

    public convertFromServerTypes(dateUtils: JhiDateUtils) {
        this.registrationDate = dateUtils.convertDateTimeFromServer(this.registrationDate);
        this.datePlanned = dateUtils.convertDateTimeFromServer(this.datePlanned);
        this.startDateReal = dateUtils.convertDateTimeFromServer(this.startDateReal);
        this.endDateReal = dateUtils.convertDateTimeFromServer(this.endDateReal);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/models/registration.model.ts